module.exports = __webpack_public_path__ + "icon-zoom-glass.svg?1daa702e24d17b602c255ec76b08f7d8";